import femaleKarmaImage from 'assets/images/gender-female-karmapath.png'
import maleKarmaImage from 'assets/images/gender-male-karmapath.png'

import { Cohort, Gender, PageVersions } from 'root-constants'
import { TPageVersion, TPartialMap, TPartialMapWithDefault } from 'root-types'

import { TGenderOption } from '../types'

export const KARMA_WELCOME_PAGE_TEST_SEGMENTS = {
  DEFAULT: 'abtest_wspkp_15_a_default',
  VARIANT_B: 'abtest_wspkp_15_b_v1',
  VARIANT_C: 'abtest_wspkp_15_c_v2',
}

const GENDER_OPTIONS_V1 = [
  {
    value: Gender.MALE,
    text: 'commonComponents.gender.man',
    imageUrl: maleKarmaImage,
  },
  {
    value: Gender.FEMALE,
    text: 'commonComponents.gender.woman',
    imageUrl: femaleKarmaImage,
  },
] as const satisfies readonly TGenderOption[]

export const GENDER_OPTIONS_BY_VERSION = {
  [PageVersions.V1]: GENDER_OPTIONS_V1,
} as const satisfies TPartialMap<TPageVersion, readonly TGenderOption[]>

export const COHORT_TO_VERSION_MAP = {
  [Cohort.KP_BS_13_C]: PageVersions.V1,
  [Cohort.KP_BS_13_H]: PageVersions.V1,
  default: PageVersions.V1,
} as const satisfies TPartialMapWithDefault<Cohort, TPageVersion>
